import FormField from 'Components/FormComponents/FormField';
import Button from 'Components/FormComponents/Button';
import {ReactComponent as SearchIcon} from 'assets/icons/search.svg';
import {ReactComponent as FiltersIcon} from 'assets/icons/filters.svg';
import {useIntl} from 'react-intl';

const SearchHeader = ({
                        formConfig,
                        searchCallback,
                        formState,
                        setFormState,
                        setFiltersState,
                        title,
                        searchButton
                      }) => {
  const intl = useIntl();

  return (
    <div className="program-finder-header">
      <h1 className='program-finder-header__title'>
        {intl.formatMessage({id: title})}
      </h1>

      <div className="flex flex-col md:flex-row lg:w-full gap-10">
        <div className="flex flex-grow">
          <FormField
            fieldConfig={formConfig}
            state={formState}
            setState={setFormState}
            onKeyPress={event => {
              if (event.key === 'Enter') {
                searchCallback(true);
              }
            }}
          />
          <Button buttonClasses="button--search-program-finder"
                  onClick={() => {
                    searchCallback(true)
                  }}>
            <div className="flex items-center md:hidden" aria-hidden={true}>
              <SearchIcon/>
            </div>
            <span className="visually-hidden md:hidden">
            {intl.formatMessage({id: searchButton})}
          </span>
            <span className="hidden md:inline">
            {intl.formatMessage({id: searchButton})}
          </span>
          </Button>
        </div>

        <div className="lg:hidden">
          <Button
            buttonClasses="button--secondary button--full-width button--filters"
            onClick={() => setFiltersState(true)}>
          <span className="md:hidden">
            {intl.formatMessage({id: 'Algolia.SearchPage.Filters.Label'})}
          </span>
            <FiltersIcon/>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default SearchHeader;
